import { Component, OnInit, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { ImagesService } from 'src/app/services/utils/images.service';
import { ServicioEntidadService, EntidadEmpresarialEntity } from 'src/app/services/servicio-entidad.service';
import { ServicioAuthService } from 'src/app/services/servicio-auth.service';
import { ReporteRibisoftEntity, ReporteRibisoftDataEntity, ServicioFacturacionService } from 'src/app/services/servicio-facturacion.service';
import { Subscription } from 'rxjs';
import { HttpErrorResponse } from '@angular/common/http';

@Component({
  selector: 'app-reporte-ribisoft',
  templateUrl: './reporte-ribisoft.component.html',
  styleUrls: ['./reporte-ribisoft.component.css']
})
export class ReporteRibisoftComponent implements OnInit, OnDestroy {

  loading: boolean;
  logo: string;
  mensajeError: string;
  mensajeLoading: string;
  usuario: string;

  fechaImpresion: Date;

  entidadEmpresarial: EntidadEmpresarialEntity;

  objectReporte: ReporteRibisoftEntity;
  dataReporte: ReporteRibisoftDataEntity[] = [];

  logoSubscription: Subscription;
  entidadSubscription: Subscription;
  dataSubscription: Subscription;

  constructor(private activatedRoute: ActivatedRoute,
              private servicioImagenes: ImagesService,
              private servicioEntidad: ServicioEntidadService,
              private servicioAuth: ServicioAuthService,
              private servicioFacturacion: ServicioFacturacionService) {
    this.activatedRoute.params.subscribe(params => {
      this.objectReporte = new ReporteRibisoftEntity();
      this.objectReporte.codigo = params['codigoBaseDatos'];
      this.objectReporte.sede = Number(params['uncoSede']);
    });
  }

  ngOnInit() {
  }

  ngOnDestroy() {
    if (this.logoSubscription) { this.logoSubscription.unsubscribe(); }
    if (this.entidadSubscription) { this.entidadSubscription.unsubscribe(); }
    if (this.dataSubscription) { this.dataSubscription.unsubscribe(); }
  }

  onFiltrosCompletados(obj: ReporteRibisoftEntity) {
    this.fechaImpresion = new Date();
    this.objectReporte = obj;
    this.usuario = this.servicioAuth.getUsuarioToken();
    this.mensajeError = null;
    this.mensajeLoading = null;
    this.getLogo();
  }

  onErrorGenerado(error: string) {
    this.mensajeError = error;
  }

  async getLogo() {
    try {
      this.logo = '';
      this.mensajeLoading = 'Cargando información del logo entidad ...';
      const response = await this.servicioImagenes.getLogo(this.objectReporte.codigo);
      this.logoSubscription = response.subscribe((data: any) => {
        this.logo = data.source;
        this.getEntidadEmpresarial();
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteRibisoft.getLogo()', err);
        this.logo = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información del logo entidad, verifique su conexión a internet e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
      console.error('Catch ReporteRibisoft.getLogo()', e);
      this.logo = null;
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al obtener información del logo entidad, intente de nuevo o reporte caso al administrador.';
    }
  }

  async getEntidadEmpresarial() {
    try {
      this.mensajeLoading = 'Cargando información entidad ...';
      const response = await this.servicioEntidad.getEntidadEmpresarial(this.objectReporte.codigo, this.objectReporte.sede);
      this.entidadSubscription = response.subscribe((data: EntidadEmpresarialEntity[]) => {
        if (data && data.length > 0) {
          this.entidadEmpresarial = data[0];
          this.getInformacionData();
        } else {
          this.entidadEmpresarial = null;
          this.mensajeLoading = null;
          this.mensajeError = 'Error al obtener información de la entidad empresarial, verifique configuración de sede y entidad.';
        }
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteRibisoft.getEntidadEmpresarial()', err);
        this.entidadEmpresarial = null;
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información de la entidad empresarial, verifique conexión a internet ' +
        'e intente de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
      console.error('Catch ReporteRibisoft.getEntidadEmpresarial()', e);
      this.entidadEmpresarial = null;
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al obtener información de la entidad empresarial, verifique conexión a internet ' +
      'e intente de nuevo. De lo contrario reporte caso al administrador.';
    }
  }

  async getInformacionData() {
    try {
      this.mensajeLoading = 'Cargando información del reporte ...';
      const response = await this.servicioFacturacion.getEstructuraRibisoft(this.objectReporte);
      this.dataSubscription = response.subscribe((data: ReporteRibisoftDataEntity[]) => {
        this.dataReporte = data;
        this.mensajeLoading = null;
        this.mensajeError = null;
      }, (err: HttpErrorResponse) => {
        console.error('Error ReporteRibisoft.getInformacionData()', err);
        this.dataReporte = [];
        this.mensajeLoading = null;
        this.mensajeError = 'Error al obtener información del reporte facturación, verifique conexión a internet de nuevo. De lo contrario reporte caso al administrador.';
      });
    } catch (e) {
      console.error('Catch ReporteRibisoft.getInformacionData()', e);
      this.dataReporte = [];
      this.mensajeLoading = null;
      this.mensajeError = 'Error grave al obtener información del reporte facturación, verifique conexión a internet de nuevo. De lo contrario reporte caso al administrador.';
    }
  }

  isLoading(): boolean {
    return this.mensajeLoading && this.mensajeLoading.length > 0;
  }

  isError(): boolean {
    return this.mensajeError && this.mensajeError.length > 0;
  }

  isReady(): boolean {
    return !this.isLoading() && !this.isError();
  }
}
